import { NgModule } from '@angular/core';
import { SpartacusConfigurationModule } from './spartacus-configuration.module';
import { SpartacusFeaturesModule } from './spartacus-features.module';
import { UrlModule } from 'haba-core';
import { BaseStorefrontModule } from './base-storefront.module';
/*import { BaseStorefrontModule } from 'haba-storefrontlib';*/

@NgModule({
  declarations: [],
  imports: [BaseStorefrontModule, SpartacusFeaturesModule, SpartacusConfigurationModule],
  exports: [
    BaseStorefrontModule,
    UrlModule, // We need this for all components, that currently don't have an own module, like footer
  ],
})
export class SpartacusModule {}
